import axios from "axios";

const _axios = axios.create();

const useOpenApiCall = () => {
  const apiCall = async (payload) => {
    const apiPayload = {
      // `url` is the server URL
      url: payload.url || "",
      // `method` is the request method
      method: payload.method || "GET",
      // `baseURL` will be prepended to `url` unless `url` is absolute.
      baseURL: payload.baseURL || "",
      // `headers` are custom headers to be sent
      headers: payload.headers || {},
      // `params` are the URL parameters to be sent with the request
      params: payload.params || {},
      // `data` is the data to be sent as the request body
      data: payload.data || {},
      config: payload.config || {},
      responseType: payload.responseType,
      cancelToken: payload.cancelToken,
    };
    try {
      const response = await _axios(apiPayload);
      if (response.data) {
        return response.data;
      }
      throw response;
    } catch (error) {
      throw error;
    }
  };

  return { apiCall };
};

export default useOpenApiCall;
